export { ResetPassword as default } from './ResetPassword';
